import React, { useRef } from 'react'
import Image from 'next/legacy/image'

import SearchInput from './SearchInput/SearchInput'
import SearchInputByCity from './SearchInput/SearchInputByCity'

import useMediaQuery from '@/utils/publicApi'
import { ICitiesByState } from '@/utils/countries_and_states'

import styles from './landingHero.module.scss'

interface ILandingHero {
  state?: string
  city?: string
  citiesByState?: ICitiesByState[]
}

export default function LandingHero({
  state,
  city,
  citiesByState,
}: ILandingHero) {
  const scrollRef = useRef(null)
  const isMobile = useMediaQuery('(max-width:600px)')

  const dataState =
    citiesByState[1].states.filter((elem) => elem.state_code === state).length >
    0
      ? citiesByState[1].states.filter((elem) => elem.state_code === state)
      : citiesByState[0].states.filter((elem) => elem.state_code === state)

  return (
    <div
      className={
        (!state && !city && styles.landingHero) ||
        (state && !city && styles.landingHero2) ||
        (state && city && styles.landingHero3)
      }
    >
      <div className={styles.wrapper}>
        <div className={styles.heroTitlesContainer}>
          <div className={styles.titles}>
            <h1 className={styles.mainTitle}>
              {state && city
                ? `Find a Local Vet in ${city}, ${state}`
                : state && !city
                  ? `Find a Local Vet in ${dataState[0]?.name}`
                  : 'Find a Local Vet'}
            </h1>
            {!state && !city && (
              <h2>
                Enter your location to find a local veterinarian close to you.
              </h2>
            )}
          </div>

          {!state && !city && (
            <div ref={scrollRef} className={styles.searchBar}>
              <SearchInput />
            </div>
          )}

          {state && !city && (
            <div ref={scrollRef} className={styles.searchBar}>
              <SearchInputByCity citiesByState={citiesByState} />
            </div>
          )}
        </div>
        <div
          className={
            !state && !city ? styles.imageContainer : styles.imageContainer2
          }
        >
          <Image
            src={
              !state
                ? '/vets/hero/main-img1-desktop.svg'
                : '/vets/hero/main-img2-desk.svg'
            }
            alt=""
            quality={75}
            layout="responsive"
            width={680.14}
            height={420.49}
            objectFit="contain"
            priority
          />
        </div>

        {!state && !city && isMobile && (
          <div ref={scrollRef} className={styles.searchBar}>
            <SearchInput />
          </div>
        )}

        {state && !city && isMobile && (
          <div ref={scrollRef} className={styles.searchBar}>
            <SearchInputByCity citiesByState={citiesByState} />
          </div>
        )}
      </div>
    </div>
  )
}
